import { RedoSideNavigation } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { filterTruthy } from "@redotech/util/array";
import { memo, useMemo } from "react";
import { useAeoNavigation } from "./aeo/aeo-navigation";
import { useConversionNavigation } from "./conversion/conversion-navigation";
import { useCustomersNavigation } from "./customers/customers-navigation";
import { useFinanceNavigation } from "./finance/finance-navigation";
import { useHomeNavigation } from "./home/home-navigation";
import { useInventoryNavigation } from "./inventory/inventory-navigation";
import { useMarketingNavigation } from "./marketing/marketing-navigation";
import { useOrdersNavigation } from "./orders/orders-navigation";
import { useSettingsItems } from "./settings";
import { useSupportNavigation } from "./support/support-navigation";

export const MerchantAppSideNav = memo(function MerchantAppSideNav({
  enterSettingsUrl,
  exitSettingsUrl,
  settingsRoot,
  hideNav,
  hideTeamSwitcher = false,
}: {
  enterSettingsUrl: string;
  exitSettingsUrl: string;
  settingsRoot: string;
  hideNav: boolean;
  hideTeamSwitcher?: boolean;
}) {
  const homeEntry = useHomeNavigation();
  const aeoEntry = useAeoNavigation();
  const conversionEntry = useConversionNavigation();
  const marketing = useMarketingNavigation();
  const orders = useOrdersNavigation();
  const inventory = useInventoryNavigation();
  const support = useSupportNavigation();
  const customers = useCustomersNavigation();
  const finance = useFinanceNavigation();

  const allPageEntries = useMemo(() => {
    return filterTruthy([
      homeEntry,
      aeoEntry,
      conversionEntry,
      marketing,
      orders,
      inventory,
      support,
      customers,
      finance,
    ]);
  }, [
    homeEntry,
    aeoEntry,
    conversionEntry,
    marketing,
    orders,
    inventory,
    support,
    customers,
    finance,
  ]);

  const settingsItems = useSettingsItems();

  return (
    <RedoSideNavigation
      enterSettingsUrl={enterSettingsUrl}
      exitSettingsUrl={exitSettingsUrl}
      hideTeamSwitcher={hideTeamSwitcher}
      isHidden={hideNav}
      pageEntries={allPageEntries}
      settingSections={settingsItems}
      settingsRoot={settingsRoot}
    />
  );
});
